const safeArrayMap = (items, callbackFunc) =>{
 
    if(Array.isArray(items)){
        return items.map(callbackFunc);
    } else{
        return [callbackFunc(items, 0)]
    }
}

export default safeArrayMap;